import type { ProductSummaryDto, SampleCardDto } from "@hisense/shared";
export function initialCardForm(card?:SampleCardDto) {
  return {productId:card?.productId??"",productNo:card?.productNo??"",subRef:card?.subRef??"",
    description:card?.description??"",type:card?.type??"",brand:card?.brand??"",color:card?.color??"",size:card?.size??"",
    customerId:card?.customerId??"",contactPerson:card?.contactPerson??"",contactPhone:card?.contactPhone??"",
    contactEmail:card?.contactEmail??"",remarks:card?.remarks??"",imageUrl:card?.imageUrl??"",imageKey:card?.imageKey??""};
}
export type CardForm=ReturnType<typeof initialCardForm>;
export function cardFieldsFromProduct(product:ProductSummaryDto):Partial<CardForm> {
  return {productId:product.id,productNo:product.productCode,subRef:product.subRef??"",description:product.description??"",
    type:product.type??"",brand:product.brandName??"",color:product.color??"",size:product.size??"",remarks:product.remarks??"",
    imageUrl:product.imageUrl??"",imageKey:""};
}
export function cardPayload(form:CardForm):CardForm {
  return Object.fromEntries(Object.entries(form).map(([key,value])=>[key,value.trim()])) as CardForm;
}
export function changedCardFields(form:CardForm,before:CardForm,recipientChanged=false):Partial<CardForm> {
  const result:Partial<CardForm>={};const payload=cardPayload(form);
  for(const key of Object.keys(form) as (keyof CardForm)[]) if(form[key]!==before[key]) result[key]=payload[key];
  if(recipientChanged) Object.assign(result,{customerId:payload.customerId,contactPerson:payload.contactPerson,contactPhone:payload.contactPhone,contactEmail:payload.contactEmail});
  return result;
}
